import type { Snippet } from 'svelte';

export type UnorderedListProps = {
  children: Snippet;
  class?: string;
};

export type ListItemProps = {
  children: Snippet;
  class?: string;
};

export const unorderedListContextKey = Symbol('athena-ul');

export type UnorderedListContext = {
  renderedItems: number;
};
